import React from "react";
import { Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useState } from "react";
import { useEffect } from "react";

import {
  getSettingState,
  setCustomModal,
  setModalType,
} from "../../../../redux/features/settingSlice";
import CustomButton from "../../CustomButton";
import useFollow from "../../../../hooks/UseFollow";

const FollowBox = ({ data, isLoading, myProfile }) => {
  const dispatch = useDispatch();
  const { userData } = useSelector(getSettingState);
  const navigate = useNavigate();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const [followBtn, setFollowBtn] = useState(false);
  const [handleFollowBtn] = useFollow(data, followBtn, setFollowBtn);

  useEffect(() => {
    data && setFollowBtn(data.followed);
  }, [data]);

  const handleFollowModal = (type) => {
    if (!userData && !urlParams[2]) {
      return null;
    } else {
      dispatch(setCustomModal(true));
      dispatch(setModalType(type));
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        mt: "16px",
        justifyContent: "space-between",
        alignItems: "center",
        mb: "30px",
        px: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {(isLoading || !data) && !myProfile ? (
          <>
            <Skeleton sx={{ ml: "auto", mr: "auto" }} width={40} height={32} />
            <Skeleton width={75} height={26} />
          </>
        ) : (
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => handleFollowModal("Followers")}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: 600,
                fontSize: "18px",
                lineHeight: "28px",
              }}
            >
              {userData || !myProfile ? data?.followers_count : "X"}
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "28px",
              }}
            >
              Followers
            </Typography>
          </Box>
        )}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", mr: "7px" }}>
        {(isLoading || !data) && !myProfile ? (
          <>
            <Skeleton sx={{ ml: "auto", mr: "auto" }} width={40} height={32} />
            <Skeleton width={75} height={26} />
          </>
        ) : (
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => handleFollowModal("Following")}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: 600,
                fontSize: "18px",
                lineHeight: "28px",
              }}
            >
              {userData || !myProfile ? data?.followings_count : "X"}
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "28px",
              }}
            >
              Following
            </Typography>
          </Box>
        )}
      </Box>
      {data ? (
        <CustomButton
          className={!myProfile && "u-follow"}
          title={myProfile ? "Edit Profile" : followBtn ? "Followed" : "Follow"}
          onClick={
            urlParams[2]
              ? () => handleFollowBtn()
              : () => navigate("/profile/editprofile")
          }
          disabled={
            (!userData && myProfile) || (data.id === userData && !myProfile)
          }
          fSize='16px'
          width='120px'
          height='40px'
          bShadow='4px'
          color={
            myProfile
              ? "primary.main"
              : followBtn
              ? "white.main"
              : "primary.main"
          }
          bgColor={
            myProfile
              ? "primary.main"
              : followBtn
              ? "black.main"
              : "primary.main"
          }
        />
      ) : (
        <CustomButton
          title='Follow'
          disabled={true}
          fSize='16px'
          width='120px'
          height='40px'
          bShadow='4px'
          color='primary.main'
          bgColor='primary.main'
        />
      )}
    </Box>
  );
};

export default FollowBox;
